import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import { CollectionCard } from "~/components/bloks/CollectionCardBlok";
import type { CollectionListingPageStoryblok } from "~/generated/sb/blok-types";
import { sizes } from "~/lib/utils/sizes";
import type { BlokData } from "~/srpc/routes/story.router";
import styles from "./CollectionListingPageBlok.module.css";

const CollectionCards = ({
	collections,
	preview,
}: {
	collections?: BlokData["collectionCards"];
	preview: boolean;
}) => {
	return collections?.map((card) => {
		if (!card.content) return null;

		return (
			<CollectionCard
				key={card?.uuid}
				preview={preview}
				imageBlok={card.content.listingImage?.[0]}
				sizes={sizes(100, 33)}
				heading={card.content.Title}
				regularTag={card.content.regularTag}
				boldTag={card.content.boldTag}
				slug={card.slug}
				fullslug={card.full_slug}
			/>
		);
	});
};

export const CollectionListingPageBlok = ({
	blok,
	data,
	preview,
}: BlokProps<CollectionListingPageStoryblok, BlokData["collectionCards"]>) => {
	if (!blok?.collections) return null;

	const ContentBloks = () =>
		blok.content?.map((content) => {
			return <StoryblokComponent blok={content} key={content._uid} preview={preview} />;
		});

	return (
		<BlokWrap as="main" editable={blok} className="collection-listing-page">
			<div className={styles.hero}>
				<h1 className={styles.title}>{blok.title}</h1>
				<p className={styles.description}>{blok.description}</p>
			</div>
			<ContentBloks />
			<div className={styles.grid} data-layout="blok">
				<CollectionCards collections={data} preview={preview} />
			</div>
		</BlokWrap>
	);
};
